import axios from 'axios';
import { getEndpoint, getRequestHeaders  } from './config'

export default function (destinationId: string) {
    return new Promise<any[]>((resolve, reject) => {
        axios
            .get(
                getEndpoint('destinations/{id}/recents', { id: destinationId }),
                getRequestHeaders(true)
            )
            .then(function (response : any) {
                resolve(response.data.sessions);
            })
            .catch(function (rs : any) {
                reject(rs);
            });
    });
}